<template>
    <div>
        <card-toolbar>
            <button @click="openNew"><i class="fas fa-plus mr-2"/>New Note</button>
        </card-toolbar>
        <card-list>
            <trip-note-list-item
                :card="card"
                :note="note"
                v-for="note in notes"
                :key="note.id"
                :active="isActive(note)"
                @click="openEdit(note)"
            />
            <container-list-item padded v-if="!notes.length">
                <p class="has-text-grey is-size-7 my-2">No notes.</p>
            </container-list-item>
        </card-list>
    </div>
</template>

<script>
    import {client as http} from '../http_client';
    import CardToolbar from "../TIER/components/CardToolbar";
    import CardList from "../TIER/components/CardList";
    import ContainerListItem from "../TIER/components/ContainerListItem";
    import TripNoteListItem from "@/components/TripNoteListItem";

    // Trips and registrations already have their own notes tables and cards
    // (trip_notes / registration_notes) -- their Notes tab is a second door to
    // the SAME notes, not a parallel store. Every other entity type uses the
    // polymorphic entity_notes API.
    const LEGACY = {
        'trip': {
            url: id => `/api/trips/${id}/notes`,
            newCard: id => ['new-trip-note', {tripId: id}],
            editCard: (id, note) => ['edit-trip-note', {tripId: id, noteId: note.id}]
        },
        'registration': {
            url: id => `/api/registrations/${id}/notes`,
            newCard: id => ['new-reg-note', {registrationId: id}],
            editCard: (id, note) => ['edit-reg-note', {registrationId: id, noteId: note.id}]
        },
        'customer': {
            url: id => `/api/users/${id}/notes`,
            newCard: id => ['new-customer-note', {userId: id}],
            editCard: (id, note) => ['edit-customer-note', {userId: id, noteId: note.id}]
        }
    };

    export default {
        name: 'EntityNotesPane',
        components: {TripNoteListItem, ContainerListItem, CardList, CardToolbar},
        props: ['card', 'child', 'entityType', 'entityId'],
        data: function () {
            return {
                notes: []
            }
        },
        computed: {
            legacy: function () {
                return LEGACY[this.entityType];
            }
        },
        methods: {
            listUrl: function () {
                return this.legacy
                    ? this.legacy.url(this.entityId)
                    : `/api/notes/entity/${this.entityType}/${this.entityId}`;
            },
            newTarget: function () {
                return this.legacy
                    ? this.legacy.newCard(this.entityId)
                    : ['new-entity-note', {entityType: this.entityType, entityId: this.entityId}];
            },
            editTarget: function (note) {
                return this.legacy
                    ? this.legacy.editCard(this.entityId, note)
                    : ['edit-entity-note', {noteId: note.id}];
            },
            openNew: function () {
                const target = this.newTarget();
                this.$openCard(target[0], target[1], this.card);
            },
            openEdit: function (note) {
                const target = this.editTarget(note);
                this.$openCard(target[0], target[1], this.card);
            },
            isActive: function (note) {
                const target = this.editTarget(note);
                return !!(this.child && this.child.definition.component === target[0]
                    && String(this.child.props.noteId) === String(note.id));
            },
            loadNotes: function (force) {
                if (!this.entityId) return;
                http.get(this.listUrl(), {force}).then(response => {
                    this.notes = response.data;
                    this.$emit('count', this.notes.length);
                });
            },
            reload: function () {
                this.loadNotes(true);
            }
        },
        watch: {
            entityId: function () {
                this.loadNotes(true);
            },
            // When a child card (new/edit note) closes or changes, the list is
            // likely stale -- panes live inside the host card, so they can't be
            // targeted by $reloadCard like standalone cards.
            child: function () {
                this.loadNotes(true);
            }
        },
        mounted() {
            this.loadNotes();
        }
    };
</script>
